import { Box, Card, CardMedia, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CommonHelper } from 'src/utils/commonHelper';
import ThreeDotLoader from 'src/utils/Loader/threeDotLoader.compontent';
import { useTranslation } from 'react-i18next';

const SnapchatMobileViewPosts = ({
  publishedPosts,
  mobileLoader,
  getMobileViewNextPosts,
  pagination,
}) => {
  const { t: translate } = useTranslation();
  const theme = useTheme();

  return (
    <Box sx={{ maxHeight: 'calc(100vh - 330px)', minHeight: 'calc(100vh - 330px)', pb: 2 }}>
      {publishedPosts.map((row, index) => (
        <Card
          key={index}
          sx={{
            display: 'flex',
            mb: 2,
            p: 1.5,
            gap: 2,
            boxShadow: 'none',
            border: `1px solid ${theme.palette.divider}`,
          }}
        >
          {(row.thumbnail_url || row.image_url) && (
            <CardMedia
              component="img"
              sx={{ width: 120, height: 120, borderRadius: 1, objectFit: 'cover' }}
              image={row.thumbnail_url || row.image_url}
              alt="story"
            />
          )}

          <Box sx={{ flex: 1 }}>
            <Typography variant="caption" color="primary.main" fontWeight={600}>
              {row.type || 'PUBLIC_STORY'}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                mt: 0.5,
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {row.description || row.caption || 'Snapchat Story'}
            </Typography>

            <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
              {CommonHelper.GetDateFormat(row.created_time || row.created_at)}
            </Typography>
          </Box>
        </Card>
      ))}

      <Box sx={{ textAlign: 'center', mt: 2 }}>
        {mobileLoader ? (
          <ThreeDotLoader />
        ) : pagination ? (
          <Typography
            variant="body1"
            sx={{
              fontWeight: 700,
              textDecoration: 'underline',
              cursor: 'pointer',
              color: theme.palette.primary.main,
            }}
            onClick={getMobileViewNextPosts}
          >
            {translate('published_post.load_more_posts')}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default SnapchatMobileViewPosts;